var render = function render(_c,_vm){return _c('a-default-stamp',{attrs:{"color":"accent","rotation":-3,"border":"0.3rem double","radius":"1rem"}},[_vm._v("Supprimé")])
}
var staticRenderFns = []

export { render, staticRenderFns }